import { Slider } from "@mui/material";
import React, { SetStateAction, useEffect, useState } from "react";
import { IsliderObjects } from "./WeightedSliders";
import {
  IBaseFilterBrokerRank,
  IBrokerRankSliderValues,
} from "./BrokerRankIndex";

const WeightedSliderReuseable = ({
  sliderObj,
  dataFilters,
  setDataFilters,
}: {
  sliderObj: IsliderObjects;
  dataFilters: IBaseFilterBrokerRank;
  setDataFilters: React.Dispatch<SetStateAction<IBaseFilterBrokerRank>>;
}) => {
  const [range, setRange] = useState(sliderObj.value);

  const handelSliderChange = (newValue: any) => {
    setRange(newValue.target.value);
  };

  const [firstLoad, setFirstLoad] = useState(false);
  useEffect(() => {
    setFirstLoad(true);
  }, []);

  // When the range updates - Trigger updating the silderObjects values.
  useEffect(() => {
    if (firstLoad) {
      const handler = setTimeout(() => {
        function isFilterKey(
          key: string,
        ): key is keyof IBrokerRankSliderValues {
          return key in dataFilters;
        }

        if (isFilterKey(sliderObj.mapping)) {
          const filterField = sliderObj.mapping; // now typed as keyof IBaseFilter
          const filterCopy = { ...dataFilters };
          filterCopy[filterField] = range;
          setDataFilters(filterCopy);
        }
      }, 500); // debounce delay in ms

      return () => {
        clearTimeout(handler); // clear timeout if range changes before delay
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range]);

  return (
    <div className="h-7 w-full">
      <div className="h-2 text-xs">{sliderObj.header}</div>
      <Slider
        getAriaLabel={() => "Date Range"}
        value={range}
        onChange={handelSliderChange}
        valueLabelDisplay="auto"
        min={1}
        max={100}
        sx={{
          color: sliderObj.color, // Tailwind's yellow-400
          "& .MuiSlider-thumb": {
            borderRadius: "4px",
            width: "6px",
            height: "14px",
          },
          "& .MuiSlider-track": {
            border: "none",
          },
          "& .MuiSlider-rail": {
            opacity: 0.5,
            backgroundColor: "#d1d5db", // Tailwind gray-300
          },
        }}
      />
    </div>
  );
};

export default WeightedSliderReuseable;
